const scrollToTopBtn = document.querySelector('.wp-block-hs-blocks-ui-component-scroll-to-top-button');

const initScrollToTopButton =()=>{

    const lookUpArr = {
        scrollY: false
    }
    
    scrollToTopBtn.addEventListener('click',(e)=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
        history.pushState(null, "", window.location.pathname + window.location.search);
    })

    const update = ()=>{

        if(lookUpArr.scrollY === window.scrollY){
            return;
        }

        if(window.scrollY >= window.innerHeight*0.5){
            scrollToTopBtn.classList.add('visible');
        }else{
            scrollToTopBtn.classList.remove('visible')
        }

        lookUpArr.scrollY = window.scrollY;
    }

    hs_core.addTask(update);
}

initScrollToTopButton();